import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import {
  Button,
  ButtonGroup,
} from 'reactstrap'
import { MdError } from 'react-icons/md'

import * as CONSTANTS from '../constants'
import { FONTS } from '../../../constants'

export default class Tab extends React.Component {
  render() {
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot')
    const project_type = get(projectByID, 'project_type')
    const activeTab = get(this.props, 'activeTab')
    const rSelected = get(this.props, 'rSelected')
    const onRadioBtnClick = get(this.props, 'onRadioBtnClick')
    const toggle = get(this.props, 'toggle')
    const canShow = project_type !== CONSTANTS.COMMON && project_type !== ''
    const isInternal = project_type === 'SPECIFIC'

    const incompletedList = this.props.incompletedList

    return (
      <Root>
        <TabWrapper>
          <NavTab
            active={ (activeTab === '1').toString() }
            onClick={ () => { toggle('1') } }
          >
          Overview
          </NavTab>
          { canShow &&
          <NavTab
            active={ (activeTab === '2').toString() }
            onClick={ () => { toggle('2') } }
          >
            Cost Planning
          </NavTab>
          }
          { canShow && !isInternal &&
          <NavTab
            active={ (activeTab === '3').toString() }
            onClick={ () => { toggle('3') } }
          >
              Revenue Planning
            { Object.keys(incompletedList).length > 0 &&
            <MdError style={ { color: '#F0C34E', marginLeft: 6, fontSize: 16 } } />
            }
          </NavTab>
          }
          { canShow &&
          <NavTab
            active={ (activeTab === '4').toString() }
            onClick={ () => { toggle('4') } }
          >
            Billing
          </NavTab>
          }
          { canShow &&
          <NavTab
            active={ (activeTab === '7').toString() }
            onClick={ () => { toggle('7') } }
          >
            Change Request
          </NavTab>
          }
          { canShow &&
          <NavTab
            active={ (activeTab === '8').toString() }
            onClick={ () => { toggle('8') } }
          >
            Attachment
          </NavTab>
          }
        </TabWrapper>
        <Group>
          { presale_snapshot &&
          <PresaleButton
            style={ {
              backgroundColor: rSelected === 1 ? '#AD2624' : '#FFFFFF',
              color: rSelected === 1 ? '#FFFFFF' : '#D44B49',
              border: '1px solid #AD2624',
            } }
            onClick={ () => onRadioBtnClick(1) }
            active={ rSelected === 1 }
          >
              Pre-sale
          </PresaleButton>
          }
          { presale_snapshot &&
          <ImplementButton
            style={ {
              backgroundColor: rSelected === 2 ? '#AD2624' : '#FFFFFF',
              color: rSelected === 2 ? '#FFFFFF' : '#D44B49',
              border: '1px solid #AD2624',
            } }
            onClick={ () => onRadioBtnClick(2) }
            active={ rSelected === 2 }
          >
            Implement
          </ImplementButton>
          }
        </Group>
      </Root>
    )
  }
}

const Root = styled.div`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
`

const TabWrapper = styled.div`
  display: flex;
  align-items: center;
`

const PresaleButton = styled(Button)`
  border-radius: 20px 0px 0px 20px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${props => {
    const status = props.active
    if (status) {
      return FONTS.GOTHAM_MEDIUM
    }
    return FONTS.GOTHAM
  }};
`

const ImplementButton = styled(PresaleButton)`
  border-radius: 0 20px 20px 0;
`

const Group = styled(ButtonGroup)`
  justify-content: flex-end;
  margin: 0 16px;
  height: 30px ;
  z-index: 10;
`

const NavTab = styled.div`
  height: 35px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin: 0 16px;
  color: ${p => (p.active === 'true' ? '#AD2624' : '#808080')};
  border-bottom: ${p => (p.active === 'true' ? '4px solid #AD2624' : 'none')};

  ${p => (p.active === 'true' && `
    margin-bottom: -4px;
  `)}
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab/index.js